import { motion } from 'framer-motion';

interface SectionDividerProps {
  variant?: 'fade' | 'line' | 'glow';
}

const SectionDivider = ({ variant = 'fade' }: SectionDividerProps) => {
  if (variant === 'line') {
    return (
      <div className="relative flex items-center justify-center py-0 overflow-hidden">
        <motion.div
          initial={{ scaleX: 0, opacity: 0 }}
          whileInView={{ scaleX: 1, opacity: 1 }}
          viewport={{ once: true, margin: '-20px' }}
          transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
          className="w-full max-w-[900px] mx-auto px-8"
        >
          <div
            className="h-px w-full"
            style={{
              background:
                'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.06) 20%, rgba(255,255,255,0.10) 50%, rgba(255,255,255,0.06) 80%, transparent 100%)',
            }}
          />
        </motion.div>
      </div>
    );
  }

  if (variant === 'glow') {
    return (
      <div className="relative h-px overflow-hidden">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: '-20px' }}
          transition={{ duration: 1.4 }}
          className="absolute inset-0"
          style={{
            background:
              'linear-gradient(90deg, transparent 0%, rgba(0,102,255,0.0) 10%, rgba(0,102,255,0.18) 35%, rgba(0,207,255,0.22) 50%, rgba(0,102,255,0.18) 65%, rgba(0,102,255,0.0) 90%, transparent 100%)',
          }}
        />
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.8, delay: 0.2 }}
          className="absolute inset-x-0 top-0 h-[6px] -translate-y-1/2 blur-sm"
          style={{
            background:
              'linear-gradient(90deg, transparent 0%, rgba(0,102,255,0.0) 15%, rgba(0,102,255,0.25) 40%, rgba(0,207,255,0.3) 50%, rgba(0,102,255,0.25) 60%, rgba(0,102,255,0.0) 85%, transparent 100%)',
          }}
        />
      </div>
    );
  }

  // Default: fade
  return (
    <div className="relative h-px overflow-hidden">
      <div
        className="absolute inset-0"
        style={{
          background:
            'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.05) 25%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.05) 75%, transparent 100%)',
        }}
      />
    </div>
  );
};

export default SectionDivider;
